import React from "react";
import { Persistor } from "redux-persist";

export const PersistorContext = React.createContext<Persistor | null>(null);

export const PersistorProvider: React.FC<{ persistor: Persistor }> = ({ persistor, children }) => (
  <PersistorContext.Provider value={persistor}>{children}</PersistorContext.Provider>
);
